import { Page, Text, Image, Document, View } from '@react-pdf/renderer';
import {
  logoBase64,
  newLogoSanlamBase64,
} from 'components/DesignationLetter/constants';
import { styles } from 'components/DesignationLetter/styles';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

const InvitationLetter = (props: any): JSX.Element => {
  const renderFooter = () => {
    if (featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)) {
      return (
        <View style={styles.newFooterletter}>
          <View style={styles.newFooterLeft}>
            <Text style={styles.newFooterLine1}>
              Assurance Non-Vie {'  •  '} Assurance Vie
            </Text>
            <Text style={styles.newFooterLine2}>
              <Text style={styles.newFooterBold}>SanlamAllianz Maroc</Text>
              {'  |  216, Bd Zerktouni  |  CP : 20000  |  Casablanca, Maroc'}
            </Text>
            <Text style={styles.newFooterLegal}>
              SanlamAllianz Maroc - société anonyme d’assurances et de
              réassurance au capital social de 534.187.400 de DH. Entreprise
              régie par la loi n° 17-99 portant code des assurances. RC
              Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
              355.11.249 - IF : 01084025 - ICE : 000230054000034
            </Text>
          </View>

          <View style={styles.newFooterRight}>
            <View style={styles.newFooterContactRow}>
              <Text style={styles.newFooterContactLabel}>T</Text>
              <Text>+212 522 42 06 06</Text>
            </View>
            <View style={styles.newFooterContactRow}>
              <Text style={styles.newFooterContactLabel}>F</Text>
              <Text>+212 522 20 60 81</Text>
            </View>
            <Text style={styles.newFooterWeb}>SanlamAllianz.ma</Text>
          </View>
        </View>
      );
    } else if (featureService.hasFeature(FEATURES.FUSION)) {
      return (
        <Text style={styles.footer}>
          Assurance Non-Vie | Assurance Vie | Sanlam Maroc | 216, Bd Zerktouni |
          CP: 20000 | Casablanca, Maroc Sanlam Maroc - société anonyme
          d’assurances et de réassurance au capital social de 534.187.400 de DH.
          Entreprise régie par la loi n° 17-99 portant code des assurances. RC
          Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
          355.11.249 IF : 01084025 - ICE : 000230054000034 T +212 522 42 06 06 F
          +212 522 20 60 81 sanlam.ma
        </Text>
      );
    } else {
      return (
        <Text style={styles.footer}>
          Assurance Non-Vie | Assurance Vie | Sanlam Maroc | 216, Bd Zerktouni |
          CP: 20000 | Casablanca, Maroc Sanlam Maroc - société anonyme
          d’assurances et de réassurance au capital social de 411.687.400 de DH.
          Entreprise régie par la loi n° 17-99 portant code des assurances. RC
          Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
          355.11.249 IF : 01084025 - ICE : 000230054000034 T +212 522 42 06 06 F
          +212 522 20 60 81 sanlam.ma
        </Text>
      );
    }
  };
  return (
    <Document>
      <Page style={styles.body}>
        <Image
          style={
            featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)
              ? styles.newImage
              : styles.image
          }
          src={
            featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)
              ? newLogoSanlamBase64
              : logoBase64
          }
        />
        <Text style={styles.content}>
          Casablanca,{' '}
          {new Date(props.data?.createdAt).toLocaleDateString('en-GB')}
        </Text>
        <Text style={styles.address}>
          {props.data?.lawyer?.ItemDescription}
        </Text>
        <Text style={styles.address}>{props.data?.lawyer?.address}</Text>
        <Text style={styles.address}>{props.data?.city?.ItemDescription}</Text>
        <Text style={styles.mission}>Pôle de gestion</Text>
        <Text style={styles.mission}>Direction automobile</Text>
        <Text style={styles.mission}>Département administratif</Text>
        <View style={styles.objectView}>
          <Text style={styles.mission}>Objet : Demande d'identification</Text>
        </View>
        <Text style={styles.mission}>N° de mission :</Text>
        <Text style={styles.mission}>
          N° dossier provisoire : {props.data?.reference}
        </Text>
        <Text style={styles.mission}>
          N° Tribunal : {props.data.courtNumber}
        </Text>
        <Text style={styles.mission}>
          Type de procédure : {props.data.procedureNature?.title}
        </Text>
        <Text style={styles.contentBody}>Cher Maitre,</Text>
        <Text style={styles.contentBody}>
          Nous nous permettons de prendre votre attache au sujet de l’affaire
          visée en objet et vous adressons ci-joint, une citation à audience qui
          se tiendra le{' '}
          {new Date(props.data?.hearingDate).toLocaleDateString('en-GB')}.
        </Text>
        <Text style={styles.contentBody}>
          Pour nous permettre d’identifier le dossier, nous vous prions de nous
          communiquer la Référence Sinistre Compagnie.
        </Text>
        <Text style={styles.contentBody}>
          A défaut, veuillez procéder à la récupération du PV et à l’ouverture
          du dossier.
        </Text>
        <Text style={styles.contentBody}>
          Au cas où cette affaire serait gérée par l’un de vos confrères, nous
          vous prions de nous communiquer son nom ainsi que ces références.
        </Text>
        <Text style={styles.contentBody}>
          Nous comptons sur votre collaboration habituelle,
        </Text>
        <Text style={styles.contentBody}>
          Veuillez agréer, Maitre l’expression de nos solutions distinguées.
        </Text>
        {renderFooter()}
      </Page>
    </Document>
  );
};

export default InvitationLetter;
